import { render, staticRenderFns } from "./UploadVideoCom.vue?vue&type=template&id=8c14340c&scoped=true"
import script from "./UploadVideoCom.vue?vue&type=script&lang=js"
export * from "./UploadVideoCom.vue?vue&type=script&lang=js"
import style0 from "./UploadVideoCom.vue?vue&type=style&index=0&id=8c14340c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c14340c",
  null
  
)

export default component.exports